import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestAssignDriver } from "./assignDriver.request";
import { AssignDriverResponse } from "./assignDriver.types";

const useAssignDriver = (
  options?: MutationOptions<AssignDriverResponse, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestAssignDriver,
    ...options
  });
};

export default useAssignDriver;
